<div class="wrap">
  <div class="badge">
    <mat-icon aria-hidden="true">auto_awesome</mat-icon>
    <span>IT'S A MATCH</span>
    <mat-icon aria-hidden="true">auto_awesome</mat-icon>
  </div>

  <div class="subtitle">
    You and <strong>{{ profile.name }}</strong> are now in a legally non-binding situationship.
  </div>

  <mat-divider></mat-divider>

  <div class="actions">
    <button mat-raised-button color="primary" (click)="goToChat()">
      <mat-icon>chat</mat-icon>
      Message Gage
    </button>

    <button mat-button (click)="close()">Keep swiping</button>
  </div>
</div>

